import {
  Scene,
  AmbientLight,
  SpotLight,
  PointLight,
  DirectionalLight,
  PMREMGenerator,
} from 'three'
import { RoomEnvironment } from 'three/addons/environments/RoomEnvironment.js'

let scene: Scene

export default function useEnvironment(_scene?: Scene) {
  if (_scene) {
    scene = _scene
  }

  function addConfiguratorLights() {
    const ambientLight = new AmbientLight(0xffffff, 0.6)
    scene.add(ambientLight)

    // const pointLight = new PointLight(0xffffff, 300)
    // pointLight.castShadow = true
    // pointLight.position.set(2, 9, 2)
    // scene.add(pointLight)

    // const environment = new RoomEnvironment()
    // const renderer = useRenderer()
    // const pmremGenerator = new PMREMGenerator(renderer.instance)
    // scene.environment = pmremGenerator.fromScene(environment).texture

    const spotLight = new SpotLight('#fff', 150)
      // spotLight.angle = Math.PI / 5
      // spotLight.penumbra = 0.3
    spotLight.position.set(0, 9, 0)
    spotLight.castShadow = true
    spotLight.shadow.camera.near = 8
    spotLight.shadow.camera.far = 200
    spotLight.shadow.mapSize.width = 512
    spotLight.shadow.mapSize.height = 512
    spotLight.shadow.bias = -0.004
    spotLight.shadow.radius = 10
    scene.add(spotLight)

    // const spotLight2 = new PointLight('#fff', 35)
    // spotLight2.position.set(0, -5, 0)
    // scene.add(spotLight2)
    // const spotLight3 = new PointLight('#fff', 25)
    // spotLight3.position.set(0, 1, -5)
    // scene.add(spotLight3)
    // const spotLight4 = new PointLight('#fff', 25)
    // spotLight4.position.set(0, 1, 5)
    // scene.add(spotLight4)

    const environment = new RoomEnvironment()

    const renderer = useRenderer()

    const pmremGenerator = new PMREMGenerator(renderer.instance)
    scene.environment = pmremGenerator.fromScene(environment).texture
    scene.environmentIntensity = 0.5

    // const dirLight = new DirectionalLight('#fff', 3)
    // dirLight.position.set(2, 9, 2)
    // dirLight.castShadow = true
    // dirLight.shadow.camera.near = 0.1
    // dirLight.shadow.camera.far = 15
    // dirLight.shadow.camera.right = 3
    // dirLight.shadow.camera.left = -3
    // dirLight.shadow.camera.top = 3
    // dirLight.shadow.camera.bottom = -3
    // dirLight.shadow.mapSize.width = 1024
    // dirLight.shadow.mapSize.height = 1024
    // dirLight.shadow.radius = 4
    // dirLight.shadow.bias = -0.0005

    // scene.add(dirLight)

    // const dirLightHelper = new CameraHelper(dirLight.shadow.camera)
    // scene.add(dirLightHelper)
  }

  function addAboutLights() {
    const ambientLight = new AmbientLight(0xffffff, 1)
    scene.add(ambientLight)

    const dirLight = new DirectionalLight(0xffffff, 2.5)
    dirLight.position.set(0, 5, 0)
    scene.add(dirLight)
  }

  return { addConfiguratorLights, addAboutLights }
}
